import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import 'moment/min/locales';
import 'antd/dist/antd.css';
// eslint-disable-next-line import/no-unresolved
import './styles/compiled/mb-default.css';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';

const store = configureStore();
render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
